import { useLang } from "../../context/LanguageContext";
import { BUSINESS } from "../../lib/api";
import { Reveal, SectionHeading } from "../Reveal";
import { toast } from "sonner";
import { MessageCircle, Mail, CalendarCheck } from "lucide-react";

export const Contact = () => {
  const { t } = useLang();

  const copyEmail = () => {
    navigator.clipboard?.writeText(BUSINESS.email);
    toast.success(t("contact.copied"));
  };

  return (
    <section id="contact" className="scroll-mt-20 bg-[#F3EFEA] px-4 sm:px-8 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionHeading center eyebrow={t("contact.eyebrow")} title={t("contact.title")} subtitle={t("contact.subtitle")} />
        </Reveal>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3">
          <Reveal>
            <a
              data-testid="contact-whatsapp-button"
              href={`https://wa.me/${BUSINESS.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex h-full flex-col items-center gap-3 rounded-2xl border border-stone-200/80 bg-white p-7 text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl text-white" style={{ background: "#25D366" }}>
                <MessageCircle className="h-7 w-7" />
              </span>
              <span className="font-serif text-xl text-stone-900">{t("contact.whatsapp")}</span>
              <span className="text-sm text-stone-500">{t("contact.whatsappDesc")}</span>
              <span className="text-sm font-semibold text-stone-700">{BUSINESS.phoneDisplay}</span>
            </a>
          </Reveal>

          <Reveal delay={0.08}>
            <button
              data-testid="contact-email-button"
              onClick={copyEmail}
              className="group flex h-full w-full flex-col items-center gap-3 rounded-2xl border border-stone-200/80 bg-white p-7 text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#C85A32] text-white">
                <Mail className="h-7 w-7" />
              </span>
              <span className="font-serif text-xl text-stone-900">{t("contact.email")}</span>
              <span className="text-sm text-stone-500">{t("contact.emailDesc")}</span>
              <span className="text-sm font-semibold text-stone-700">{BUSINESS.email}</span>
            </button>
          </Reveal>

          <Reveal delay={0.16}>
            <button
              data-testid="contact-form-button"
              onClick={() => document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" })}
              className="group flex h-full w-full flex-col items-center gap-3 rounded-2xl border border-stone-200/80 bg-white p-7 text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#5F6B52] text-white">
                <CalendarCheck className="h-7 w-7" />
              </span>
              <span className="font-serif text-xl text-stone-900">{t("contact.form")}</span>
              <span className="text-sm text-stone-500">{t("contact.formDesc")}</span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
